import { useMediaQuery } from "@mui/material";
import {
	LANDSCAPE_MEDIA_QUERY,
	MOBILE_MEDIA_QUERY,
	resolveResponsiveLayout,
	type ResponsiveLayout,
} from "./responsiveLayout";

export interface ResponsiveView {
	/** Which layout tree should render. */
	layout: ResponsiveLayout;
	/** Derived from `layout` — never settable on its own, so the two can't disagree. */
	isMobile: boolean;
}

/**
 * The single source of truth for device classification.
 *
 * Asks two questions — "is this a phone?" and "is it on its side?" — because width alone cannot
 * answer the first: a landscape phone is 844-956px wide. See `responsiveLayout.ts` for the queries
 * and why each clause is shaped the way it is.
 *
 * Callers that only route between a desktop and a mobile tree want `isMobile`; only the two map
 * widgets, which swap a bottom sheet for a side sheet, need the full `layout`.
 */
export const useResponsiveView = (): ResponsiveView => {
	const narrowOrShort = useMediaQuery(MOBILE_MEDIA_QUERY);
	const shortLandscape = useMediaQuery(LANDSCAPE_MEDIA_QUERY);
	const layout = resolveResponsiveLayout({ narrowOrShort, shortLandscape });
	return { layout, isMobile: layout !== "desktop" };
};
